import { ValueType } from "@/enums/ValueType";
import { aowLeeftijd } from "./aowLeeftijd";
import { forfaitSchijven } from "./eigenwoningforfaitschijven";
import { factorTweedeInkomen } from "./factorTweedeInkomen";
import { inkomstenbelastingSchijven } from "./inkomstenbelastingschijven";
import { nhgKostengrens } from "./nhgKostengrens";
import { nhgPremie } from "./nhgPremie";
import { woonquotePercentages } from "./woonquotePercentages";
import { extraLeenbedragenEnergielabel } from "./extraLeenbedragenEnergielabel";

export const parameters = {
	fictiefKredietRekenpercentage: {
		metadata: {
			type: ValueType.Percentage,
		},
		values: {
			"2021-01-01": { value: 0.02 },
		},
	},
	fictieveToetsrenteGrens: {
		metadata: {
			type: ValueType.Number,
		},
		values: {
			"2021-01-01": { value: 120 },
		},
	},
	fictieveToetsrente: {
		metadata: {
			type: ValueType.Percentage,
		},
		values: {
			"2021-01-01": { value: 0.05 },
		},
	},
	gewogenRenteAfrondingsDecimalen: {
		metadata: {
			type: ValueType.Number,
		},
		values: {
			"0000-01-01": { value: 6 },
		},
	},
	woonquoteRenteAfrondFactor: {
		metadata: {
			type: ValueType.Number,
		},
		values: {
			"0000-01-01": { value: Math.pow(10, 6) },
		},
	},
	ovbPercentages: {
		values: {
			"2011-01-01": { value: [{ label: "2%", value: 0.02 }] },
			"2021-01-01": {
				value: [
					{ label: "0%", value: 0 },
					{ label: "2%", value: 0.02 },
					{ label: "8%", value: 0.08 },
				],
			},
			"2023-01-01": {
				value: [
					{ label: "0%", value: 0 },
					{ label: "2%", value: 0.02 },
					{ label: "10,4%", value: 0.104 },
				],
			},
			"2026-01-01": {
				value: [
					{ label: "0%", value: 0 },
					{ label: "2%", value: 0.02 },
					{ label: "8%", value: 0.08 },
					{ label: "10,4%", value: 0.104 },
				],
			},
		},
	},
	maximaleAftrek: {
		metadata: {
			type: ValueType.Percentage,
		},
		values: {
			"2020-01-01": { value: 0.46 },
			"2021-01-01": { value: 0.43 },
			"2022-01-01": { value: 0.4 },
			"2023-01-01": { value: 0.371 },
		},
	},
	minDeelHoogte: {
		metadata: {
			type: ValueType.Currency,
		},
		values: { "2021-01-01": { value: 2_500 } },
	},
	bankgarantieAdministratiekostenPercentage: {
		metadata: {
			type: ValueType.Percentage,
		},
		values: { "2021-01-01": { value: 0.002 } },
	},
	bankgarantiePercentageKoopsom: {
		metadata: {
			type: ValueType.Percentage,
		},
		values: {
			"2021-01-01": { value: 0.1 },
		},
	},
	bankgarantieBankkosten: {
		metadata: {
			type: ValueType.Percentage,
		},
		values: {
			"2021-01-01": { value: 0.009 },
		},
	},
	bankgarantiekostenMinimaleHoogte: {
		metadata: {
			type: ValueType.Currency,
		},
		values: {
			"2021-01-01": { value: 100 },
		},
	},
	extraLenenAlleenstaand: {
		values: {
			"2024-01-01": { value: 16000 },
			"2025-01-01": { value: 17000 },
		},
	},
	extraLenenGrens: {
		values: {
			"2025-01-01": { value: (aow?: boolean) => (aow ? 29000 : 30000) },
		},
	},
	aowLeeftijd,
	extraLeenbedragenEnergielabel,
	factorTweedeInkomen,
	forfaitSchijven,
	inkomstenbelastingSchijven,
	nhgPremie,
	nhgKostengrens,
	woonquotePercentages,
};
